<template>
    <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="保管物品">
            <div class="content_main">
                <div class="content_main_top">
                    <a-form @keyup.enter.native="handleSubmitSerch()">
                        <a-input type="text" class="a_input_self margin_self" placeholder="请输入物品名称" allowClear
                            v-model="name" @keyup.enter.native="handleSubmitSerch" />
                        <a-button type="primary" @click="handleSubmitSerch()" style="margin: 5px"> 搜索 </a-button>
                    </a-form>
                </div>
                <div class="content_main_center_scroll" id="content_main_center_scroll">
                    <a-table :columns="columns" :data-source="lis" bordered :pagination="pagination" :loading="loading"
                        @change="handleTableChange" :scroll="{ y: scroll_y }">

                    </a-table>
                </div>
            </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="责任物品">
            <div class="content_main">
                <div class="content_main_top">
                    <a-form @keyup.enter.native="handleSubmitSerch2()">
                        <a-input type="text" class="a_input_self margin_self" placeholder="请输入物品名称" allowClear
                            v-model="name" @keyup.enter.native="handleSubmitSerch2" />
                        <a-button type="primary" @click="handleSubmitSerch2()" style="margin: 5px"> 搜索 </a-button>
                    </a-form>
                </div>
                <div class="content_main_center_scroll" id="content_main_center_scroll">
                    <a-table :columns="columns2" :data-source="lis2" bordered :pagination="pagination2"
                        :loading="loading2" @change="handleTableChange2" :scroll="{ y: scroll_y }">

                    </a-table>
                </div>
            </div>
        </a-tab-pane>
    </a-tabs>
</template>

<script>
import {
    keeperAsset,
    dutyAsset,
} from '@/api/activiti'
const columns = [{
    title: '物品编号',
    dataIndex: 'assetSn',
},
{
    title: '物品名称',
    dataIndex: 'name',
},
{
    title: '型号',
    dataIndex: 'model',
},

{
    title: '物品类型',
    dataIndex: 'assetTypeName',
},
{
    title: '物品状态',
    dataIndex: 'goodStatus',
},
{
    title: '责任人',
    dataIndex: 'charger',
},
]
const columns2 = [{
    title: '物品编号',
    dataIndex: 'assetSn',
},
{
    title: '物品名称',
    dataIndex: 'name',
},
{
    title: '型号',
    dataIndex: 'model',
},

{
    title: '物品类型',
    dataIndex: 'assetTypeName',
},
{
    title: '物品状态',
    dataIndex: 'goodStatus',
},
{
    title: '保管人',
    dataIndex: 'keeper',
},
]
export default {
    data() {
        return {
            lis: [],
            name: '',
            loading: false,
            pagination: {
                current: 1,
                pageSize: 30,
                total: 0,
                pageSizeOptions: ['30', '50', '100'],
                showLessItems: true,
                showSizeChanger: true,
            },
            columns,
            scroll_y: 150,
            lis2: [],
            name2: '',
            loading2: false,
            pagination2: {
                current: 1,
                pageSize: 30,
                total: 0,
                pageSizeOptions: ['30', '50', '100'],
                showLessItems: true,
                showSizeChanger: true,
            },
            columns2,
        }
    },
    mounted() {
        this.init();
        this.$nextTick(() => {
            var max_h = $('#content_main_center_scroll').height()
            setTimeout(() => {
                this.scroll_y = max_h - $('.ant-table-header').height() - 40
            }, 1000)
        })
    },
    methods: {
        init() {
            this.get_keeperAsset()
            this.get_dutyAsset();

        },
        // 获取保管物品信息
        get_keeperAsset() {
            this.loading = true;
            keeperAsset({
                keeper: this.$store.getters.userInfo.userName,
                pageIndex: this.pagination.current,
                pageSize: this.pagination.pageSize,
                name: this.name
            }).then(res => {
                this.lis = res.rows
                this.loading = false
                const pagination = {
                    ...this.pagination
                }
                pagination.total = res.total
                this.pagination = pagination
            })

        },
        //搜索
        handleSubmitSerch() {
            this.loading = true
            this.pagination.current = 1
            this.get_keeperAsset()
        },
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.get_keeperAsset()
        },
        // 获取责任物品信息
        get_dutyAsset() {
            this.loading2 = true
            dutyAsset({
                charger: this.$store.getters.userInfo.userName,
                pageIndex: this.pagination2.current,
                pageSize: this.pagination2.pageSize,
                name: this.name2
            }).then(res => {
                this.lis2 = res.rows
                this.loading2 = false
                const pagination = {
                    ...this.pagination2
                }
                pagination.total = res.total
                this.pagination2 = pagination
            })
        },
        //搜索
        handleSubmitSerch2() {
            this.loading2 = true
            this.pagination2.current = 1
            this.get_dutyAsset()
        },
        handleTableChange2(pagination, filters, sorter) {
            this.pagination2.current = pagination.current
            this.pagination2.pageSize = pagination.pageSize
            this.get_dutyAsset()
        },
    }
}
</script>

<style lang="scss" scoped>
</style>